<section class="__body">
  <router-outlet></router-outlet>
</section>
<awair-footer></awair-footer>
